import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { first, mergeMap } from "rxjs/operators";

import { AuthJwtService } from "./auth-jwt.service";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private authJwtService: AuthJwtService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (request.headers.has("authorization")) {
      return next.handle(request);
    }

    return this.authJwtService.martJwtToken.pipe(
      first(),
      mergeMap((jwt) => {
        if (jwt == null) {
          return next.handle(request);
        }

        const requestWithAuth = request.clone({
          setHeaders: {
            authorization: `Bearer ${jwt}`
          }
        });
        return next.handle(requestWithAuth);
      })
    );
  }
}
